import { render } from "./FinanceiroResultadoTab.vue?vue&type=template&id=106fe6dc&scoped=true"
import script from "./FinanceiroResultadoTab.vue?vue&type=script&lang=js"
export * from "./FinanceiroResultadoTab.vue?vue&type=script&lang=js"

import "./FinanceiroResultadoTab.vue?vue&type=style&index=0&id=106fe6dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106fe6dc"]])

export default __exports__